class FileTypes {
  static mimeTypes = {
    Image: [
      "image/bmp",
      "image/gif",
      "image/jpeg",
      "image/png",
      "image/svg+xml",
      "image/tiff",
      "image/x-icon",
      "image/webp"
    ]
  };

  static anyValid(validTypes, files) {
    return [...files].some(file => {
      return validTypes.includes(FileTypes.findByMime(file.type));
    });
  }

  static findByMime(mimeType) {
    let type;
    for (
      let i = 0, max = Object.keys(FileTypes.mimeTypes).length;
      i < max;
      i += 1
    ) {
      const key = Object.keys(FileTypes.mimeTypes)[i];
      const mimes = FileTypes.mimeTypes[key];
      if (mimes.includes(mimeType)) {
        type = key;
        break;
      }
    }
    return type;
  }

  /**
   * Determines if the provided mime type exists within
   * the expected fileType,
   *
   * @param {String} expectedType Type that will be checked
   * @param {String} mimeType mime type from the file being checked
   * @returns {Boolean}
   */
  static validType(expectedType, mimeType) {
    if (!FileTypes.mimeTypes[expectedType]) return false;
    return FileTypes.mimeTypes[expectedType].includes(mimeType);
  }
}

export default FileTypes;
